"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10.0101c0 1.8031.983 3.4503 2.5022 4.541.134.089.201.2226.201.4007 0 .0445-.0223.1113-.0223.1558-.1117.4452-.3128 1.1798-.3351 1.202-.0224.0668-.0447.1113-.0447.1781 0 .1336.1117.2449.2457.2449.0447 0 .0894-.0223.134-.0446l1.5863-.9126c.1117-.0668.2457-.1113.3798-.1113.067 0 .1563 0 .2234.0223.7372.2225 1.5415.3338 2.368.3338 3.999 0 7.2384-2.6934 7.2384-6.0101C16.4767 6.6934 13.2373 4 9.2384 4 5.2394 4 2 6.6934 2 10.0101z",
    fill: "url(#a)"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9825 19.5572c.6909 0 1.3595-.0897 1.9613-.2691.0445-.0224.1114-.0224.1783-.0224.1114 0 .2228.0448.312.0897l1.3149.7625c.0446.0224.0669.0449.1114.0449a.2004.2004 0 0 0 .2006-.2019c0-.0448-.0223-.0897-.0223-.157 0-.0224-.1783-.6279-.2674-1.0092-.0223-.0448-.0223-.0897-.0223-.1345 0-.1346.0669-.2467.1783-.3365C21.1976 17.4042 22 16.0362 22 14.5112c0-2.781-2.6967-5.0461-6.0175-5.0461-3.3207 0-6.0174 2.2427-6.0174 5.0461 0 2.7809 2.6967 5.046 6.0174 5.046z",
    fill: "url(#b)"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.7557 8.0696c0 .5192-.411.9303-.9302.9303-.5192 0-.9302-.411-.9302-.9303 0-.5192.411-.9302.9302-.9302.5192 0 .9302.411.9302.9302zm4.8257 0c0 .5192-.411.9303-.9302.9303-.5192 0-.9303-.411-.9303-.9303 0-.5192.4111-.9302.9303-.9302s.9302.411.9302.9302z",
    fill: "#187E28"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2327 12.9534c0 .4522.3617.8139.8139.8139a.8106.8106 0 0 0 .814-.8139.8106.8106 0 0 0-.814-.814.8106.8106 0 0 0-.8139.814zm-4.0118 0c0 .4522.3618.8139.814.8139a.8106.8106 0 0 0 .814-.8139.8106.8106 0 0 0-.814-.814.8106.8106 0 0 0-.814.814z",
    fill: "#858C8C"
  }), _react.default.createElement("defs", null, _react.default.createElement("linearGradient", {
    id: "a",
    x1: "9.2464",
    y1: "15.9877",
    x2: "9.2464",
    y2: "4.0556",
    gradientUnits: "userSpaceOnUse"
  }, _react.default.createElement("stop", {
    stopColor: "#78D431"
  }), _react.default.createElement("stop", {
    offset: "1",
    stopColor: "#9EEE69"
  })), _react.default.createElement("linearGradient", {
    id: "b",
    x1: "15.9932",
    y1: "19.4712",
    x2: "15.9932",
    y2: "9.4612",
    gradientUnits: "userSpaceOnUse"
  }, _react.default.createElement("stop", {
    stopColor: "#E4E6E6"
  }), _react.default.createElement("stop", {
    offset: "1",
    stopColor: "#F5F5FF"
  })))];
};

exports.default = _default;